export { View as Tab2024 } from './view'
